import { Box, Flex, Radio, Stack, Text } from '@mantine/core'

import { RadioCard } from '@/components/RadioCard'
import type { PresentationStyle } from '@/services/api/api.types'
import * as classes from '@/styles/TemplateSelectionCards.css'

interface TemplateSelectionCardsProps {
  templates: PresentationStyle[]
  onTemplateSelect: (template: PresentationStyle) => void
  isLoading?: boolean
  hasError?: boolean
}

export function TemplateSelectionCards({
  templates,
  onTemplateSelect,
  isLoading = false,
  hasError = false,
}: TemplateSelectionCardsProps) {
  if (isLoading || templates.length === 0) {
    return null
  }

  return (
    <Box
      style={{
        minHeight: '200px',
        backgroundColor: 'white',
        borderRadius: 'var(--mantine-radius-md)',
        padding: 'var(--mantine-spacing-lg)',
        border: hasError ? '2px solid var(--mantine-color-red-5)' : '1px solid var(--mantine-color-gray-4)',
      }}>
      <Stack gap="lg" align="center">
        <Text size="md" fw="600" c={hasError ? 'red' : 'dark'} ta="center" className={classes.title}>
          Choose a delivery style template to get started:<sup style={{ color: 'red' }}>*</sup>
        </Text>
        <Radio.Group className={classes.radioGroup}>
          <Flex wrap="wrap" gap="md" justify="center" className={classes.cardContainer}>
            {templates.map(template => (
              <RadioCard
                key={template.presentationStyleId}
                value={template.presentationStyleId}
                label={template.displayName || template.name}
                description={template.description}
                onClick={() => onTemplateSelect(template)}
                className={classes.card}
              />
            ))}
          </Flex>
        </Radio.Group>
      </Stack>
    </Box>
  )
}
